import React from "react";
import Draggable from "react-draggable";
import DecorationSingleItem from "./decorationSingleItem";

export default function DecorationItem({ decoration }) {
  const preventDefault = (e) => {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
    }
    e.returnValue = false;
  };

  const disableScroll = () => {
    document.addEventListener("wheel", preventDefault, {
      passive: false,
    });
  };

  const enableScroll = () => {
    document.removeEventListener("wheel", preventDefault, {
      passive: false,
    });
  };

  return (
    <Draggable bounds={{ top: -500, left: -800, right: 500, bottom: 100 }}>
      <div className="body-item-default" style={{maxHeight: '800px', maxWidth: '800px'}}>
        <DecorationSingleItem
          decoration={decoration}
          enableScroll={enableScroll}
          disableScroll={disableScroll}
        />
      </div>
    </Draggable>
  );
}
